import Moment from 'moment';
/**
 * Generates hour values for the car booker dropdown.
 * @params (Boolean) militaryLabel - Tells which kind of time label to generate
 * @params (Boolean) militaryValue - Tells which kind of time value to generate
 **/
function generateAgeDropdownItems() {
  const ages = [];

  for (let age = 18; age < 30; age++) {
    ages.push({
      name: age.toString(),
      value: age.toString(),
    });
  }

  ages.push(
    {
      name: '30 - 65',
      value: '30-65',
    },
    {
      name: '66+',
      value: '66',
    }
  );

  return ages;
}

function generateTimeDropdownItems(militaryLabel, militaryValue) {
  const times = [];

  let amPm = militaryLabel ? '' : 'AM';
  let hour = militaryLabel ? 0 : 12;
  let hourValue = militaryValue ? 0 : 12;
  let mins = 0;
  while (times.length != 48) {
    const formattedHours = hour < 10 ? `0${hour}` : hour;
    const formattedHoursValue = hourValue < 10 ? `0${hourValue}` : hourValue;
    const formattedMins = mins % 1 > 0 ? '30' : '00';

    const stamp = `${formattedHours}:${formattedMins} ${amPm}`;
    const value = `${formattedHoursValue}:${formattedMins}${!militaryValue ? amPm : ''}`;

    times.push({ name: stamp, value: value });
    mins += .5;
    hour = mins % 1 > 0 ? hour : hour + 1;
    hourValue = mins % 1 > 0 ? hourValue : hourValue + 1;
    if (!militaryLabel) {
      hour = hour > 12 ? hour - 12 : hour ;
      amPm = times.length > 23 ? 'PM' : 'AM';
    }

    if (!militaryValue) {
      hourValue = hourValue > 12 ? hourValue - 12 : hourValue ;
    }
  }

  return times;
}

/**
 * Generates Day Values for the Birthday Dropdown Component.
 **/
function generateDayDropdownItems() {
  const days = [];
  let day = 1;
  while (days.length != 31) {
    days.push({ name: day.toString().padStart(2, '0'), value: day });
    day++;
  }

  return days;
}

/**
 * Generates Month Values for the Birthday Dropdown Component..
 **/
function generateMonthDropdownItems() {
  const months = [];

  Moment.monthsShort().forEach((monthShort, i) => {
    const monthNum = i + 1;

    months.push({
      name: monthShort,
      value: monthNum,
    });
  });

  return months;
}
/**
 * Generates Month Values by number for the Birthday Dropdown Component..
 **/
function generateMonthByNumberDropdownItems() {
  const months = [];

  Moment.monthsShort().forEach((monthShort, i) => {
    const monthNum = i + 1;
    months.push({
      name: monthNum < 10 ? `0${ monthNum }` : `${ monthNum }`,
      value: monthNum,
    });
  });

  return months;
}


function generateMonthNumbersDropdownItems() {
  const months = [];

  for (let i = 1; i <= 12; i++) {
    months.push({
      name: String(i).padStart(2, '0'),
      value: i,
    });
  }

  return months;
}

/**
 * Generates Year Values for the Birthday Dropdown Component.
 **/
function generateYearDropdownItems(min, max) {
  const years = [];

  let year = Moment().year() - max;
  while (years.length != (max - min)) {
    years.push({ name: year.toString(), value: year });
    year++;
  }

  return years.reverse();
}

export {
  generateAgeDropdownItems,
  generateDayDropdownItems,
  generateMonthByNumberDropdownItems,
  generateMonthDropdownItems,
  generateMonthNumbersDropdownItems,
  generateTimeDropdownItems,
  generateYearDropdownItems,
};
